/** "Hozir qo'ng'iroq qilsa bo'ladi" sozlamasi (backend: registry.clean_callnow) */
export interface CallNowConfig {
  /** Qo'ng'iroq oynasi, driver mahalliy soatida: [boshlanish, tugash) */
  call: [number, number];
  limit: 5 | 10 | 20;
}

export const LIMITS = [5, 10, 20] as const;

export const defaultCallNowConfig = (): CallNowConfig => ({ call: [9, 20], limit: 10 });

export function parseCallNowConfig(raw: unknown): CallNowConfig {
  const d = defaultCallNowConfig();
  if (!raw || typeof raw !== "object") return d;
  const r = raw as Record<string, unknown>;
  const call = Array.isArray(r.call) && r.call.length === 2 && r.call.every((h) => Number.isInteger(h)) && 0 <= r.call[0] && r.call[0] < r.call[1] && r.call[1] <= 24
    ? ([r.call[0], r.call[1]] as [number, number])
    : d.call;
  const limit = (LIMITS as readonly number[]).includes(r.limit as number) ? (r.limit as CallNowConfig["limit"]) : d.limit;
  return { call, limit };
}
